<template>
    <!-- 右边主体[[ -->
    <div class="g-content information g-autofixheight">
        <!-- 内容数据-全部 [[ -->
        <div class="information-whole-con information-con">
            <!-- 不做tab组件直接连接跳转 -->
            <div class="information-tab g-tab">
                <a class="inf-tab-con inf-tab-whole f-inlineblock-top" href="javascript:;" :class="{'g-tab-item-active': item.deliverSource === params.deliverSource}" v-for="item in tabList" :key="item.deliverSource" @click="changeTab(item)">{{item.name}}</a>
            </div>
            <!-- 条件筛选 [[ -->
            <div class="inf-filter">
                <h5 class="inf-filter-tit">条件筛选<span class="ico f-inlineblock-top" :class="isShowChoice ? 'ico-up' : 'ico-down'" @click="showChoice"></span></h5>
                <ul class="inf-filter-con" v-show="isShowChoice">
                    <li class="inf-con-tit">
                        <p class="inf-filter-con-tit f-inlineblock-top">内容标题</p>
                        <input class="inf-con-tit-input g-input" type="text" name=""
                               value="" @change="getList" v-model.lazy.trim="params.searchText" placeholder="请输入内容标题">
                    </li>
                    <!-- 交互说明
                        活动tab下才显示
                     -->
                    <li class="inf-select" v-show="params.deliverSource == 5">
                        <p class="inf-filter-con-tit f-inlineblock-top">活动名称</p>
                        <dropdown :list="activityList" ref="activityDropdown" @change="chooceActivity" placeholder="请选择或输入活动名称"></dropdown>
                    </li>
                    <!-- 交互说明
                        订单tab下才显示
                     -->
                     <li class="inf-select" v-show="params.deliverSource == 3">
                        <p class="inf-filter-con-tit f-inlineblock-top">订单名称</p>
                        <dropdown :list="orderList" ref="orderDropdown" @change="chooceOrder" placeholder="请选择或输入订单名称"></dropdown>
                    </li>
                    <li class="inf-publish-time">
                        <p class="inf-filter-con-tit f-inlineblock-middle">发布时间</p>
                        <div class="inf-publish-time-date f-inlineblock-middle">
                            <el-date-picker
                                v-model="dateVal"
                                type="daterange"
                                range-separator="至"
                                :start-placeholder="defaultsDate"
                                :end-placeholder="defaulteDate"
                                :picker-options="pickerOptions"
                                value-format="yyyy-MM-dd"
                                @change="onDateChange"
                            >
                            </el-date-picker>
                        </div>
                    </li>
                    <li class="inf-label">
                        <p class="inf-filter-con-tit f-inlineblock-top">类型</p>
                        <div class="inf-label-con f-inlineblock-top">
                            <a class="inf-label-btn g-btn" href="javascript:;" v-for="item in articleTypeList" :key="item.aType" :class="{'js-inf-btn-active': item.aType === params.aType}" @click="changeType(item)">{{item.name}}</a>
                        </div>
                    </li>
                    <li class="inf-label allmedia" :class="{'auto-height': showMore}">
                        <p class="inf-filter-con-tit f-inlineblock-top">媒体</p>
                        <div class="inf-label-con f-inlineblock-top">
                            <a class="inf-label-btn g-btn" href="javascript:;" :class="{'js-inf-btn-active': params.cid === ''}" @click="changeMedia()">全部</a>

                            <a class="inf-label-btn g-btn" href="javascript:;" v-for="item in mediaList" :key="item.id" :class="{'js-inf-btn-active': params.cid === item.id}" @click="changeMedia(item.id)">{{item.text}}</a>
                        </div>
                        <span class="media-more ico f-inlineblock-top" :class="showMore ? 'ico-down' : 'ico-up'" @click="showMore = !showMore"></span>
                    </li>
                    <!-- <li class="inf-label">
                        <p class="inf-filter-con-tit f-inlineblock-top">账号</p>
                        <div class="inf-label-con f-inlineblock-top">
                            <a class="js-inf-btn-active inf-label-btn g-btn" href="javascript:;">全部</a>
                        </div>
                    </li> -->
                </ul>
            </div>
            <!-- 条件筛选 ]] -->
            <div class="inf-chart">
                <div class="inf-total f-inlineblock-top">
                    <p class="inf-total-tit">总发布量</p>
                    <p class="inf-total-num">{{staticData.totalPubNum}}</p>
                    <p class="inf-total-tit">总阅读量</p>
                    <p class="inf-total-num">{{staticData.totalPV ? staticData.totalPV : 0}}</p>
                </div>
                <div class="inf-chart-con f-inlineblock-top">
                    <div class="inf-chart-radio">
                        <!-- 单选选中的添加class="inf-radio-active"反之去掉class="inf-radio-active" -->
                        <label class="inf-label" v-for="item in echartRadio" :key="item.val" @click="getAudioData(item)">
                            <div class="inf-radio-con f-inlineblock-middle" :class="{'inf-radio-active': audioParams.curAudio===item.val}">
                                <!-- <input class="g-input" type="radio" name="chart" v-model="item.val"> -->
                            </div>
                            <p class="inf-radio-name f-inlineblock-top">{{item.name}}</p>
                        </label>
                    </div>
                    <div id="chart-wrap"></div>
                </div>
            </div>
            <div class="profit">
                <div class="profit-list">
                    <table class="profit-table" style="max-height:316px;overflow: hidden;">
                        <tr class="profit-table-head bg-gray">
                            <th style="width:300px" class="profit-td-1 profit-td-border">
                                <p style="width:300px" class="profit-td-con">文章标题</p>
                            </th>
                            <th style="width:100px" class="profit-td-2 profit-td-border" >
                                <p style="width:100px" class="profit-td-con">发布日期</p>
                            </th>
                            <th class="profit-td-3 profit-td-border">
                                <p class="profit-td-con">类型</p>
                            </th>
                            <th class="profit-td-3 profit-td-border">
                                <p class="profit-td-con">15天阅读量</p>
                            </th>
                            <th class="profit-td-3">
                                <p class="profit-td-con">操作</p>
                            </th>
                        </tr>
                        <template v-if="articleList.length>0">
                            <tr
                                class="profit-table-tr"
                                v-for="(item,index) in articleList"
                                :key="index"
                            >
                                <template>
                                    <td class="profit-td-1">
                                        <p class="profit-td-con" style="width: 300px;" :title="item.articleTitle">{{item.articleTitle}}</p>
                                    </td >
                                    <td style="width:100px" class="profit-td-2">
                                        <p class="profit-td-con" style="width: 100%;">{{item.publishDate}}</p>
                                    </td>
                                    <td class="profit-td-3 profit-td-border">
                                        <p class="profit-td-con" v-text="getArticleType(item)"></p>
                                    </td>
                                    <td class="profit-td-3 profit-td-border">
                                        <p class="profit-td-con">{{item.PVVV}}</p>
                                    </td>
                                    <td class="profit-td-3">
                                        <p class="btn">
                                            <a class="g-btn js-see-trend-btn" href="javascript:;" @click="showTrend(item)">查看趋势</a>
                                        </p>
                                    </td>
                                </template>
                            </tr>
                        </template>
                        <tr class="profit-table-tr" v-else>
                            <td colspan="5" align="center" class="profit-td-border">
                                <p style="text-align: center;">没数据</p>
                            </td>
                        </tr>
                    </table>
                </div>
                <pagination
                    :total="count"
                    :page-size="params.pageSize"
                    @change="pageChange"
                    ref="pager">
                </pagination>
            </div>
        </div>
        <!-- 账号设置 ]] -->

        <!-- 弹窗 [[ -->
        <trend-pop ref="trend"></trend-pop>
        <!-- 发布渠道信息弹窗 -->
        <channel-pop ref="channel"></channel-pop>
        <!--内容预览 start-->
        <content-preview ref="contentPreview"></content-preview>
        <video-preview ref="videoPreview"></video-preview>
        <!-- 弹窗 ]] -->
    </div>
    <!-- 右边主体]] -->
</template>
<style lang="scss" scoped>
    @import '~Assets/sass/pages/v4/information/information.scss';
    #chart-wrap{
        width: 100%;
        height: 250px;
    }
    .inf-label{
        cursor: pointer;
    }
    .inf-label.allmedia{
        position: relative;
    }
    .auto-height{
        height: 60px;
        overflow: hidden;
    }
    .media-more{
        position: absolute;
        top: 13px;
        right: 24px;
    }
</style>
<script>
import pagination from 'Components/v4/pagination/pagination_v4';
import channelPop from 'Components/v4/pop/channel_pop';
import trendPop from './_trend_pop';
import dropdown from './_dropdown';
import contentPreview from 'Components/v4/pop/content_preview';
import videoPreview from 'Components/v4/pop/video_preview';
import selectBox from 'Components/v4/dropdown/select_box';
import G2 from '@antv/g2';
import {
    GetArticleList, GetExternalChannels, DataGetStatistics, GetUserActivityList, GetUserOrderList, Get15DaysStatistics
} from 'Services/getData.js';
export default {
    data() {
        return {
            audioParams: {
                curAudio: 0
            },
            pickerOptions: {
                    
                disabledDate(time) {
                    return time.getTime() > Date.now(); //这里就是设置当天后的日期不能被点击
                }
            },
            dateVal: [],
            showMore: true,
            defaultsDate: '',
            defaulteDate: '',
            defaultDate: [],
            echartRadio: [
                {
                    name: '发布量',
                    val: 0
                },
                {
                    name: '阅读量',
                    val: 1
                }
            ],
            tabList: [
                {
                    name: '全部',
                    deliverSource: ''
                },
                {
                    name: '自由投稿',
                    deliverSource: 4
                },
                // {
                //     name: '活动投稿',
                //     deliverSource: 5,
                // },
                {
                    name: '订单投稿',
                    deliverSource: 3
                },
                {
                    name: '活动投稿',
                    deliverSource: 7
                }
            ],
            articleTypeList: [
                {
                    name: '全部',
                    aType: ''
                },
                {
                    name: '图文',
                    aType: 0
                },
                {
                    name: '视频',
                    aType: 1
                },
                {
                    name: '小说',
                    aType: 50
                },
                {
                    name: '漫画',
                    aType: 60
                }
            ],
            params: {
                deliverSource: '',
                aType: '',
                searchText: '',
                sDate: '',
                eDate: '',
                cid: '',
                pageIndex: 0,
                pageSize: 10
            },
            count: 0, //总记录数
            isShowChoice: true, //条件筛选展开
            isShowChannel: false,
            articleList: '',
            mediaList: '',
            staticData: {},
            activityList: [],
            orderList: [],
            curActivity: {},
            curOrder: {},
            chart: ''
        }
    },
    components: {
        pagination,
        channelPop,
        trendPop,
        selectBox,
        dropdown,
        contentPreview,
        videoPreview
    },
    mounted(){
        this.getExternalChannels();

        let startDate = Date.now() - 8.64e7*7;
        let endDate = Date.now() - 8.64e7;
        this.params.sDate = this.$common.formatDate(startDate, '-');
        this.params.eDate = this.$common.formatDate(endDate, '-');
        this.dateVal[0] = this.$common.formatDate(startDate, '-');
        this.dateVal[1] = this.$common.formatDate(endDate, '-');
        this.defaultsDate = this.dateVal[0];
        this.defaulteDate = this.dateVal[1];
        this.getList();
        this.getTotal();
        this.getUserActivityList();
        this.getUserOrderList();
    },
    methods: {
        preview(article){
            if(article.articleType == 0){
                this.$refs.contentPreview.loadInfo(article.id);
            }else if(article.articleType == 1){
                this.$refs.videoPreview.remotePreview(article.id);
            }else{
                this.$refs.contentPreview.loadInfo(article.id);
            }
        },
        disabledDate (time) {
            return time.getTime() > Date.now();
        },
        drawLine(item){
            this.$nextTick( ()=> {
                let data = [];
                let xy = 'iTime*pubNum';
                if(item.val == 0 || item.curAudio == 0){
                    xy = 'iTime*pubNum';
                }else{
                    xy = 'iTime*PVVV';
                }

                data = this.staticData.data;
                if(this.chart){
                    this.chart.destroy();
                }
                this.chart = new G2.Chart({
                    container: 'chart-wrap',
                    forceFit: true,
                    width: '100%',
                    height: 250,
                    padding: [ 20, 50, 45, 50 ]
                });
                    
                let chart = this.chart;

                let defs = {
                    'pubNum': {
                        alias: '发布量'
                    },
                    'PVVV': {
                        alias: '阅读量'
                    }
                };
                chart.source(data, defs);
                chart.scale('value', {
                    min: 0
                });
                chart.scale('iTime', {
                    range: [0, 1]
                    // tickInterval: 20
                });
                chart.tooltip({
                    crosshairs: {
                        type: 'line'
                    }
                });
                chart.line().position(xy).color('#FD7E28');
                chart.point().position(xy).size(4).shape('circle').style({
                    stroke: '#FD7E28',
                    fill: '#FD7E28',
                    lineWidth: 1
                });
                    
                chart.render();
                G2.track(false)
            })
        },
        chooceActivity(item){
            this.params.activityId = item.id;
            this.getList();
        },
        chooceOrder(item){
            this.params.orderId = item.id;
            this.params.orderType = item.type;
            this.getList();
        },
        getUserActivityList(){
            // 活动列表
            GetUserActivityList().then((res)=>{
                this.activityList = res.data.data;
            })
        },
        getUserOrderList(){
            // 订单列表
            GetUserOrderList().then((res)=>{
                this.orderList = res.data.data;
            });
        },
        showChannelList(item){
            if(item.show == undefined){
                item.show = false;
            }
            item.show = !item.show;
        },
        getAudioData(item){
            this.audioParams.curAudio = item.val;
            this.drawLine(item);
        },
        showTrend(item){
            item.sDate = this.params.sDate
            item.eDate = this.params.eDate;
            this.$refs.trend.getData(item);
            this.$refs.trend.mediaList = this.mediaList;
            this.$refs.trend.show = true;
        },
        showChannel(item){
            this.$refs.channel.show = true;
            console.log(item);
            this.$refs.channel.getList(item);
        },
        changeMedia(id = ''){
            this.params.cid = id;
            this.getList();
        },
        async getExternalChannels(){
            let res = await GetExternalChannels();
            this.mediaList = res.data.data;
        },
        getArticleType(item){
            let type = ''
            switch(parseInt(item.articleType)){
            case 0:
                type = '图文';
                break;
            case 1:
                type = '视频';
                break;
            case 50:
                type = '小说';
                break;
            case 60:
                type = '漫画';
                break;
            default:
                type = '其他';
                break;
            }
            return `【${type}】`;
        },
        getDeliverSource(item){
            let deliverSource = ''
            switch(parseInt(item.deliverSource)){
            case 4:
                deliverSource = '自由投稿';
                break;
            case 3:
                deliverSource = '订单投稿';
                break;
                // case 5:
                //     deliverSource = '活动投稿';
                //     break;
            case 7:
                deliverSource = '活动投稿';
                break;
            default:
                deliverSource = '未知投稿方式';
                break;
            }
            return deliverSource;
        },
        async getList(reset = true){
            if(reset){
                this.params.pageIndex = 0;
                this.$refs.pager.reload();
            }
            // let res = await GetArticleList(this.params);
            let res = await Get15DaysStatistics(this.params);
            if(res.status === 200 && res.data.code === 0){
                res.data.data.data.forEach((v, k)=>{
                    v.show = false;
                })
                this.articleList = res.data.data.data;
                this.count = res.data.data.total;
                this.getTotal();
            }
        },
        async getTotal(){
            let res = await DataGetStatistics(this.params);
            if(res.status == 200 && res.data.code == 0){
                this.staticData = res.data.data;
            }
            this.drawLine(this.audioParams);
        },
        onDateChange(choiceDate){
            if(this.dateVal != null){
                this.params.sDate = this.dateVal[0];
                this.params.eDate = this.dateVal[1];
                this.getList();
            }
        },
        showChoice(){
            this.isShowChoice = !this.isShowChoice;
        },
        changeType(item){
            this.params.aType = item.aType;
            this.getList();
        },
        changeTab(item){
            if(item.deliverSource == 4){
                this.articleTypeList = [
                    {
                        name: '全部',
                        aType: ''
                    },
                    {
                        name: '图文',
                        aType: 0
                    },
                    {
                        name: '视频',
                        aType: 1
                    }
                ]
                this.params.deliverSource = ''
            }else{
                this.articleTypeList = [
                    {
                        name: '全部',
                        aType: ''
                    },
                    {
                        name: '图文',
                        aType: 0
                    },
                    {
                        name: '视频',
                        aType: 1
                    },
                    {
                        name: '小说',
                        aType: 50
                    },
                    {
                        name: '漫画',
                        aType: 60
                    }
                ]
            }
            this.params.deliverSource = item.deliverSource;
            this.getList(false);
        },
        pageChange (param) {
            this.params.pageSize = param.pageSize; // 发送给接口的字段
            this.params.pageIndex = param.pageIndex-1; // 发送给接口的字段
            this.getList(false);
        }
    }
}
</script>
<style lang="scss" scoped>
@import '~Assets/sass/pages/v4/common/_config_theme.scss';
.profit {
    background: $color-bg;
    .ptc-profit {
        padding-bottom: 30px;
        font-size: 0;
    }
    .ptc-profit-con {
        display: inline-block;
        width: 277px;
        height: auto;
        margin-right: 19px;
        padding: 10px 15px;
        vertical-align: top;
        color: $color-bg;
    }
    .ptc-total-revenue {
        background: url(~Assets/img/pages/v4/img-6.png) no-repeat;
    }
    .recent-earnings {
        background: url(~Assets/img/pages/v4/img-7.png) no-repeat;
    }
    .profit-account {
        margin: 0;
        background: url(~Assets/img/pages/v4/img-8.png) no-repeat;
    }
    .profit-tit,.total-revenue-num {
        font-size: 14px;
        line-height: 20px;
    }
    .total-revenue-num {
        width: 276px;
        height: 20px;
        text-align: right;
    }
    .profit-num {
        padding: 8px 0;
        font-size: 26px;
        font-weight: bold;
        line-height: 33px;
    }
    .money-icon {
        margin: 0 5px;
        font-size: 20px;
        line-height: 1;
    }
    .money-num {
        display: inline-block;
        width: 260px;
        vertical-align: top;
    }
    .profit-tab {
        padding-left: 30px;
        border-bottom: 1px solid $color-border2;
    }
    .profit-con-tab {
        padding: 40px 0;
        font-size: 0;
        text-align: center;
    }
    .profit-con-label {
        display: inline-block;
        width: 147px;
        height: 28px;
        margin: 0 10px;
        border: 1px solid $color-theme;
        font: {
            size: 14px;
            weight: bold;
        };
        vertical-align: top;
        color: $color-theme;
        line-height: 28px;
        border-radius: 28px;
        cursor: pointer;
    }
    .color-theme-active,.profit-day .profit-day-btn,
    .profit-month .profit-month-btn {
        background: $color-theme;
        color: $color-bg;
    }
    .profit-con {
        width: 902px;
        margin: 0 auto;
    }
    .profit-chart,.profit-table {
        margin: 0 auto;
        width: 900px;
        border: 1px solid $color-border1;
        border-radius: 2px;
        box-shadow: 0 4px 10px 0 rgba(233,233,233,0.50);
        text-align: center;
    }
    .profit-chart {
        padding-top: 20px;
        font-weight: bold;
        color: $color-gray;
    }
    .day-month-btn {
        width: auto;
        height: 23px;
        margin-left: 20px;
        border: 1px solid $color-theme;
        font-size: 0;
        border-radius: 23px;
        color: $color-theme;
    }
    .dmb-con {
        display: inline-block;
        width: 41px;
        height: 23px;
        font-size: 14px;
        line-height: 23px;
        border-radius: 23px;
        vertical-align: top;
        text-align: center;
        cursor: pointer;
    }
    .profit-month-btn {
        margin-left: -10px;
    }
    .profit-time-name,.profit-time-con {
        line-height: 25px;

    }
    .profit-time-name {
        padding-left: 20px;
        font: {
            size: 14px;
            weight: bold;
        }
        color: $color-gray;
    }
    .profit-time-con {
        position: relative;
        padding-left: 30px;
        font: {
            size: 14px;
            weight: bold;
        }
        color: $color-gray;
        .ico-calendar {
            margin-left: 13px;
        }
    }
    .profit-chart-top {
        padding-bottom: 23px;
    }
    .profit-table {
        margin-top: 38px;
    }
    .profit-table-head {
        width: 100%;
        height: 60px;
        border-bottom: 1px solid $color-border1;
        font-size: 14px;
        color: #999999;
        .profit-td-border {
            .profit-td-con {
                height: 42px;
                border-right-color: $color-border1;
                line-height: 42px;
            }
        }
    }
    .profit-td-1 {
        width: 85px;
        padding-left: 20px;
        // text-align: left;
        .profit-td-con {
            width: 85px;
        }
    }
    .profit-td-border {
        width: 139px;
        // padding-left: 10px;
        .profit-td-con {
            width: 118px;
            padding-right: 21px;
            border-right: 1px solid transparent;
            // text-align: left;
        }
    }
    .profit-table-tr {
        height: 50px;
        border-bottom: 1px solid #F5F5F5;
        font-size: 14px;
        line-height: 50px;
        color: $color-gray;
        .profit-td-con {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        .profit-td-border {
            color: #191b1f;
        }
    }
    .profit-td-2 {
        width: auto;
        .profit-td-con {
            width: 109px;
        }
    }
    .profit-td-6 {
        position: relative;
        padding-left: 70px;
        text-align: left;
        cursor: pointer;
        .profit-td-con {
            display: inline-block;
            width: 122px;
            padding-right: 10px;
            font-weight: bold;
            vertical-align: middle;
            line-height: 20px;
        }
        .profit-con-popup {
            position: absolute;
            top: 51px;
            left: -10px;
            width: 160px;
            height: auto;
            padding: 20px;
            background: $color-bg;
            border: 1px solid $color-border1;
            box-shadow:  0 0 10px 0 rgba(214,214,214,0.50);
            border-radius: 2px;
            line-height: 20px;
            z-index: 10;
        }
        .ico-small-triangle {
            position: absolute;
            top: -18px;
            left: 88px;
            width: 38px;
            height: 18px;
            background: url(~Assets/img/pages/v4/icon.png) no-repeat -96px -124px;
        }
    }
    .profit-td-con-box {
        display: inline-block;
        vertical-align: middle;
        line-height: 1;
    }
    .bg-gray{
        background: $color-menu-hover;
    }
    .g-pagination {
        padding-bottom: 30px;
    }
    .g-calendar {
        top: 40px;

    }
    .profit-day,.profit-detail {
        .ico-popup-triangle {
            left: 180px;
        }
    }
    .profit-detail {
        .profit-time-name {
            padding-left: 0;

        }
        .profit-table {
            margin: 0;
        }
        .profit-td-border .profit-td-con {
            width: 140px;
            padding-right: 10px;
        }
        .profit-td-top,.profit-td-bottom {
            line-height: 1;
            text-align: left;
        }

        .profit-td-top {
            padding: 0 0 12px 10px;
        }
        .after-tax,.surrender {
            width: 66px;
            text-align: right;
        }
        .after-tax {
            margin-right: 4px;
        }
        .profit-td-6 {
            padding-left: 15px;
        }
        .profit-con-popup {
            left: -26px;
        }
        .ico-small-triangle {
            left: 40px;
        }
    }
    .profit-tab {
        .g-tab-item {
            font-weight: bold;
        }
    }
}
.profit-month {
    .g-calendar {
        width: 535px;
        height: 226px;
        .date-option {
            width: 235px;
            height: 170px;
            .date-years-month,.date-table {
                width: 195px;
            }
            .date-td {
                margin-right: 25px;
            }
        }
        .calendar-date {
            width: 503px;
        }
    }
    .ico-popup-triangle {
        left: 140px;
    }
    .js-end-active .tr-color {
        width: 72%;
    }
}
.flow-reward,.order-profit,.activity-profit {
    .profit-inf {
        .profit-td-1,.profit-td-2 {
            width: 231px;
            .profit-td-con {
                width: 231px;
            }
        }

    }
    .profit-inf,.reward-detail{
       .profit-td-border {
           .profit-td-con {
                border: none;
            }
        }
    }
    .reward-detail {
        .profit-td-1 {
            width: 242px;
            .profit-td-con {
                width: 242px;
            }
        }
        .profit-td-2 {
            width: 450px;
            text-align: left;
            .profit-td-con {
                width: 450px;
                font-weight: bold;
            }
        }
        .profit-table {
            margin: 0;
        }
        .profit-time-name {
            padding: 0;
        }
        .ico-popup-triangle {
            left: 180px;
        }
    }

}
.flow-reward {

    .reward-detail {
        .profit-td-1 {
            width: 242px;
            .profit-td-con {
                width: 242px;
            }
        }
        .profit-td-2 {
            width: 300px;
            // text-align: left;
            .profit-td-con {
                width: 300px;
                font-weight: bold;
            }
        }
        .profit-table {
            margin: 0;
        }
    }
    .profit-detail {
        .profit-td-1 {
            width: 212px;
            .profit-td-con {
                width: 212px;
            }
        }
        .profit-td-2 {
            width: 232px;
            .profit-td-con {
                width: 232px;
            }
        }
        .profit-td-3 {
            width: 370px;
            text-align: right;
            .profit-td-con {
                width: 370px;
                border-color: transparent;
            }
        }
    }
}
.el-range-editor {
        height: 35px;
}
.el-date-table {
    td.in-range{
        div {
            background-color:#FFEAD7;
        }
    }
}
.order-profit,.activity-profit {
    .profit-detail {
        .profit-td-1 {
            width: 149px;
            .profit-td-con {
                width: 149px;
            }
        }
        .profit-td-2 {
            width: 137px;
            .profit-td-con {
                width: 117px;
            }
        }
        .profit-td-3 {
            width: 210px;
            text-align: right;
            .profit-td-con {
                width: 140px;
            }
        }
        .profit-td-4 {
            width: 200px;
            // text-align: left;
            .profit-td-con {
                width: 200px;
                font-weight: bold;
            }
        }
    }
}

</style>
